import InfoCardLabelComponent from './InfoCardLabelComponent';
export * from './InfoCardLabelComponent';
export default InfoCardLabelComponent;
